import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

export default class BlockKeyNumbers {
	static init() {
		document.querySelectorAll(".block-key-numbers .number .value").forEach(item => {
			let obj = { value: 0 };
			gsap.to(obj, {
				value: item.dataset.value,
				duration: 1.5, // Durée fixe de 3s
				ease: "linear",
				onUpdate: () => {
					item.innerText = Math.floor(obj.value);
				},
				onComplete: () => {
					item.innerText = item.dataset.value;
				},
				scrollTrigger: {
					trigger: item,
					start: "top 90%",
				}
			});
		});
	}
}
